export class NonceRequestDTO {
  user_num_key: string;
  year_month: string;
  nonce: string;

  constructor(userNumKey: string, yearMonth: string, nonce: string) {
    this.user_num_key = userNumKey;
    this.year_month = this.addHyphen(yearMonth);
    this.nonce = nonce;
  }

  private addHyphen(yearMonth: string): string {
    if (yearMonth.includes('-')) {
      return yearMonth;
    }

    return yearMonth.slice(0, 4) + '-' + yearMonth.slice(4, 6);
  }
}
